/**
 * @generated SignedSource<<31f909ca1c43cbafdb37ee3f9eeec555>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NftAuctionStatus = "CANCELED" | "ENDED" | "LIVE" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useLatestAuctionInfo_nftAuction$data = {
  readonly auctionId: number | null;
  readonly currentBid: {
    readonly wei: string | null;
  } | null;
  readonly endDate: string | null;
  readonly status: NftAuctionStatus | null;
  readonly winnerAddress: {
    readonly address: string | null;
  } | null;
  readonly " $fragmentType": "useLatestAuctionInfo_nftAuction";
};
export type useLatestAuctionInfo_nftAuction$key = {
  readonly " $data"?: useLatestAuctionInfo_nftAuction$data;
  readonly " $fragmentSpreads": FragmentRefs<"useLatestAuctionInfo_nftAuction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useLatestAuctionInfo_nftAuction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "auctionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherAmount",
      "kind": "LinkedField",
      "name": "currentBid",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "wei",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "winnerAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftAuction",
  "abstractKey": null
};

(node as any).hash = "2049ae97d517dbce648d7ab20cac0d8f";

export default node;
